/**
 * Created by vaibhav on 31/3/18
 */
module.exports = {
    siteTitle: "Rémi Blot", // Site title.
    siteTitleAlt: "Rémi Blot, Digital Agency", // Alternative site title for SEO.
    siteLogo: "/logos/logo-512x512.png", // Logo used for SEO and manifest.
    siteUrl: "https://remiblot.com", // Domain of your website without pathPrefix.
    pathPrefix: "", // Prefixes all links. For cases when deployed to example.github.io/gatsby-starter-business/.    "/"
    siteDescription: "Rémi Blot, Digital Agency", // Website description used for RSS feeds/meta description tag.
    siteRss: "/rss.xml",
    siteFBAppID: "", // FB Application ID for using app insights
    googleTagManagerID: "", // GTM tracking ID.
    disqusShortname: "RB", // Disqus shortname.
    userName: "RB",
    userTwitter: "",
    userLocation: "",
    userDescription: "",
    copyright: "© 2021 RÉMI BLOT", // Copyright string for the footer of the website and RSS feed.
    footerT1: "RB • RB",
    themeColor: "#ddd", // Used for setting manifest and progress theme colors.
    backgroundColor: "#ffffff", // Used for setting manifest background color.
    closingDay: 3,
    dayOn: "11.30",
    dayOff: "23.30",
    phoneBooking: "",
    dialBooking: "",
    webcam: "#",
    insta:"https://www.instagram.com/remiblot/",
    fb:"https://www.facebook.com/remi.blot.14",
    pint:"#"
};



// WEBPACK FOOTER //
// ./meta/config.js